(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;
  if (!document.querySelector('.s561')) return;
  var load = document.querySelector('.s561-load');

  function begin(){
    body.classList.add('s561-done');
    setTimeout(function(){ body.classList.add('s561-go'); }, 380);
  }

  if (reduce || !load){ body.classList.add('s561-done','s561-go'); }
  else {
    var el = load.querySelector('.s561-count'), t0 = null;
    requestAnimationFrame(function tick(t){
      if (!t0) t0 = t;
      var e = Math.min((t - t0) / 1500, 1);
      el.textContent = Math.round((1 - Math.pow(1 - e, 3)) * 100);
      if (e < 1) requestAnimationFrame(tick); else begin();
    });
  }

  document.querySelectorAll('.s561-hero .s561-m').forEach(function(m,i){
    if (m.firstElementChild) m.firstElementChild.style.transitionDelay = (i*.085)+'s';
  });

  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(en){
        if (en.isIntersecting){ en.target.classList.add('s561-seen'); io.unobserve(en.target); }
      });
    }, {threshold:.2});
    document.querySelectorAll('.s561-item').forEach(function(n){ io.observe(n); });

    var io2 = new IntersectionObserver(function(es){
      es.forEach(function(en){
        if (en.isIntersecting){
          en.target.querySelectorAll('.s561-m > *').forEach(function(c,i){
            c.style.transitionDelay = (i*.07)+'s'; });
          en.target.classList.add('s561-go'); io2.unobserve(en.target);
        }
      });
    }, {threshold:.35});
    document.querySelectorAll('.s561-state').forEach(function(n){ io2.observe(n); });
  } else {
    document.querySelectorAll('.s561-item').forEach(function(n){ n.classList.add('s561-seen'); });
  }

  document.querySelectorAll('.s561-frame img').forEach(function(im){
    function bail(){ if (im.parentNode) im.parentNode.removeChild(im); }
    im.addEventListener('error', bail);
    if (im.complete && im.naturalWidth === 0) bail();
  });

  if (!reduce && matchMedia('(hover:hover)').matches){
    var cur = document.querySelector('.s561-cur');
    if (cur){
      var tx = innerWidth/2, ty = innerHeight/2, cx = tx, cy = ty;
      addEventListener('mousemove', function(e){ tx = e.clientX; ty = e.clientY; });
      (function loop(){
        cx += (tx-cx)*0.14; cy += (ty-cy)*0.14;
        cur.style.transform = 'translate('+cx+'px,'+cy+'px) translate(-50%,-50%)';
        requestAnimationFrame(loop);
      })();
      document.querySelectorAll('a,button').forEach(function(a){
        a.addEventListener('mouseenter', function(){ cur.classList.add('s561-fat'); });
        a.addEventListener('mouseleave', function(){ cur.classList.remove('s561-fat'); });
      });
    }
  }
})();
